var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuest = function SvgGuest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2m6 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2m6 0h2a2 2 0 0 1 2 2v12c0 .667-.4 2-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m0 16v-2.675a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2V21H9Zm5-9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgGuest;